import { useState, useEffect } from "react";

export function useIsMobile() {
  const widthThreshold = 640;
  const heightThreshold = 700;
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= widthThreshold || window.innerHeight <= heightThreshold
  );

  useEffect(() => {
    function handleResize() {
      setIsMobile(
        window.innerWidth <= widthThreshold ||
          window.innerHeight <= heightThreshold
      );
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [widthThreshold, heightThreshold]);

  return isMobile;
}
